/// <amd-module name="Test/ManageTestPlans/ManageTestPlansHub" />

import * as React from "react";
import { DirectoryView } from "Test/ManageTestPlans/Components/DirectoryView";
import { IDirectoryPivot, IMyFavoriteTestPlanPayload } from "Test/ManageTestPlansCommon/Contracts";
import { DirectoryPivotType, TestPlanRouteParameters } from "Test/ManageTestPlansCommon/Constants";
import * as Resources from "Test/ManageTestPlans/Resources";
import { LoadingComponent } from "Test/ManageTestPlans/Components/LoadingComponent";
import { IVssComponentContext, VssComponent, WrappedComponent } from "VSS/Platform/Layout";
import { getRouteValues } from "VSS/Platform/Navigation";
import * as Utils_String from "VSS/Core/Util/String";
import { IVssPerformanceService, IVssScenario } from "VSS/Platform/Performance";
import { IVssPageContext } from "VSS/Platform/Context";
import { TcmPerfScenarios } from "Test/ManageTestPlansCommon/Constants";
import { isAdvancedTestExtensionEnabled } from "Test/ManageTestPlans/LicenseUtils";
import { getAssetLocation } from "VSS/Platform/Location";
import { Link } from "VSSUI/Link";
import { TestPlanDirectorySource } from "Test/ManageTestPlans/Sources/TestPlanDirectorySource";

class ManageTestPlansHubState {
    isLoading: boolean;
    showAdvertisement: boolean;
}

export class ManageTestPlansHub extends VssComponent<any, ManageTestPlansHubState, IVssComponentContext> {
    constructor(props: any, context: IVssComponentContext) {
        super(props);
        const routeValues = getRouteValues(context.pageContext);
        this._pivotName = routeValues[TestPlanRouteParameters.Pivot].toLowerCase();
        this._pageContext = context.pageContext;
        this._source = TestPlanDirectorySource.getInstance();
        this._source.init(this._pageContext);
        this._hasTestPlans().then(
            (value: boolean) => {
                this.setState({ isLoading: false, showAdvertisement: !value });
            },
            (error: any) => {
                this.setState({ isLoading: false, showAdvertisement: true });
            }
        );
    }

    public compomemtDidMount(): void {
        this.setState({ isLoading: true });
    }

    public render() {
        let selectedPivotType = ManageTestPlansHub.getDirectoryPivotTypeFromString(this._pivotName, DirectoryPivotType.mine);
        const pivots: IDirectoryPivot[] = [
            {
                name: Resources.MineText,
                type: DirectoryPivotType.mine
            },
            {
                name: Resources.AllText,
                type: DirectoryPivotType.all
            }
        ];

        if (selectedPivotType == DirectoryPivotType.all || isAdvancedTestExtensionEnabled(this._pageContext)) {
            return <DirectoryView selectedPivot={selectedPivotType} pivots={pivots} />;
        } else {
            if (this.state && !this.state.isLoading) {
                if (!isAdvancedTestExtensionEnabled(this._pageContext) && this.state.showAdvertisement) {
                    return <WrappedComponent dependencies={["ms.vss-test-web.tcm-advertisement"]} wrappedType={"tcmAdvertisementPage"} />;
                } else {
                    return <DirectoryView selectedPivot={selectedPivotType} pivots={pivots} />;
                }
            } else {
                return <LoadingComponent />;
            }
        }
    }

    public static getDirectoryPivotTypeFromString(pivotName: string, defaultValue: DirectoryPivotType): DirectoryPivotType {
        let result: DirectoryPivotType = defaultValue;

        if (Utils_String.equals(pivotName, DirectoryPivotType.all, /*ignorecase*/ true)) {
            result = DirectoryPivotType.all;
        } else if (Utils_String.equals(pivotName, DirectoryPivotType.mine, /*ignorecase*/ true)) {
            result = DirectoryPivotType.mine;
        }

        return result;
    }

    public componentDidMount(): void {
        let selectedPivotType = ManageTestPlansHub.getDirectoryPivotTypeFromString(this._pivotName, DirectoryPivotType.mine);
        let scenarioName, perfDescriptor;

        if (selectedPivotType === DirectoryPivotType.all) {
            scenarioName = TcmPerfScenarios.LoadTestPlansAllNonTTI;
        } else if (selectedPivotType === DirectoryPivotType.mine) {
            scenarioName = TcmPerfScenarios.LoadTestPlansMineNonTTI;
        }

        if (scenarioName) {
            perfDescriptor = this._perfService.startScenario(scenarioName, false);
        }
    }

    public _hasTestPlans(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this._source.getMyFavoriteTestPlanData().then(
                (myFavoriteTestPlans: IMyFavoriteTestPlanPayload) => {
                    resolve(myFavoriteTestPlans ? myFavoriteTestPlans.hasTestPlans : false);
                },
                (reason: any) => {
                    reject("Error");
                }
            );
        });
    }

    private get _perfService() {
        return this._pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
    }

    private _pivotName: string;
    private _pageContext: IVssPageContext;
    private _source: TestPlanDirectorySource;
}

VssComponent.register("manageTestPlans", ManageTestPlansHub);
